import { render } from "./sensitive.vue?vue&type=template&id=4620a3f6"
import script from "./sensitive.vue?vue&type=script&lang=js"
export * from "./sensitive.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__